import { createContext } from "react";
import { DEFAULT_THEME } from "../themes/default";

export const ThemeContext = createContext(DEFAULT_THEME);
